import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MDBBadge, MDBBtn, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBInput, MDBRow, MDBTable } from 'mdb-react-ui-kit';
import PageHeader from '../../components/page/PageHeader';
import PageBody from '../../components/page/PageBody';
import TableHeader from '../../components/table/TableHeader';
import TableBody from '../../components/table/TableBody';
import '../../components/MusButton.css';
import TorneoStore from '../../stores/TorneoStore';
import Confirmation from '../../components/Confirmation';

export default function EditorTorneo() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isTorneoEditable, SetIsTorneoEditable] = useState(false);
  const [torneo, setTorneo] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [doubletToDelete, setDoubletToDelete] = useState();
  const [hiddeColumns, setHiddeColumns] = useState();
  const [hiddeColumnsBool, setHiddeColumnsBool] = useState(false);
 
  useEffect(() => {
    let id = searchParams.get('torneoId');
    let idNum = id ? parseInt(id) : -1;
    if (idNum === -1) {
      setTorneo({id: -1, name: '', date: (new Date()).getMilliseconds(), status: 'No Iniciado', turns: 2, doublets: [], numZeros: 3, numJuegos: 3, roundNum: -1, championType: 'EliminatoriaNoCondicionada'})
      SetIsTorneoEditable(true);
    } else {
      let _listadoTorneos = TorneoStore.getInstance().getAllTorneos();
      _listadoTorneos?.forEach((torneoItem) => {
        if (torneoItem.id === idNum) {
          setTorneo(JSON.parse(JSON.stringify(torneoItem)));
          SetIsTorneoEditable(torneoItem.status === 'No Iniciado');
        }
      });
    }
    window.scrollTo(0, 0);
  },[]);

  useEffect(() => {
    setHiddeColumns(window.innerWidth < 1023 ? 'none':'table-cell');
    setHiddeColumnsBool(window.innerWidth < 1023);
  });

  const saveTorneo = (item) => {
    if (item.id === -1) {
      TorneoStore.getInstance().addTorneo(item);
    } else {
      TorneoStore.getInstance().saveTorneo(item);
    }
    // setTorneos(TorneoStore.getInstance().getAllTorneos());
    navigate('/listadoTorneos')
  }

  const cancelTorneoEdition = () => {
    navigate('/listadoTorneos')
  }

  const addDoublet = (torneoId) => {
    let newDoublet = [...torneo.doublets];
    newDoublet.push({
      id: -1,
      avatarId: 5,
      nameDoublet: '',
      namePlayer: [],
      status: 'Continua',
      results: [],
      earned: 0,
      losses: 0,
      exents: 0,
    });
    newDoublet.map((item, index) => {
      item.id = index + 1;
    })
    setTorneo({...torneo, doublets: [...newDoublet]});
  }

  const deleteDoublet = () => {
    const torneoDoublets = [...torneo.doublets];
    let newSetOfDoublets = torneoDoublets.filter((doubleItem) => doubleItem.id !== doubletToDelete);

    setTorneo({...torneo, doublets: [...newSetOfDoublets]})

    setShowConfirmation(false);
  }

  const cancelAction = () => {
    setShowConfirmation(false);
  }

  return (
    torneo && <>
      <PageHeader title={`Torneo '${torneo.name}' - Parejas`}></PageHeader>
      <PageBody>
        <Confirmation
              show={showConfirmation}
              setShow={setShowConfirmation}
              title="Confirmacion"
              message="Seguro que desea ELIMINAR esta pareja?"
              cancelAction={cancelAction}
              aceptAction={deleteDoublet}
        ></Confirmation>
        <MDBRow>
          <div className={'d-flex ' + (hiddeColumnsBool ? 'justify-content-around' : 'justify-content-end') + ' p-3'}>
            <MDBBtn className='musButton-md m-1' onClick={()=>{cancelTorneoEdition()}}>
              {isTorneoEditable ? 'Cancelar' : 'Cerrar'}
            </MDBBtn>
            <MDBBtn className='musButton-md m-1' onClick={()=>{saveTorneo(torneo)}} hidden={!isTorneoEditable}>
              Grabar
            </MDBBtn>
            <MDBBtn className='musButton-md m-1' onClick={()=>{addDoublet(torneo?.id)}} hidden={!isTorneoEditable}>
              <MDBIcon className='me-2' fas icon='address-card' /> {hiddeColumnsBool ? 'Añadir' :  'Añadir Pareja'}
            </MDBBtn>
          </div>
        </MDBRow>
        <MDBRow>
          <MDBCol className="mb-3" md="9" sm="12"> 
            <MDBInput type='text' size="lg" label="Nombre del Torneo" defaultValue={torneo.name} onChange={(e)=>{setTorneo({ ...torneo, name: e.target.value})}} disabled={!isTorneoEditable}/>
          </MDBCol>
          <MDBCol className="mb-3" md="3" sm="12">
            <MDBInput type='date' size="lg" label="Fecha" defaultValue={torneo.date} onChange={(e)=>{setTorneo({ ...torneo, date: e.target.value})}} disabled={!isTorneoEditable}/>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol className="mb-3" md="2" sm="12">
            <MDBInput type='number' size="lg" label="Num. Zeros" defaultValue={torneo.numZeros} onChange={(e)=>{setTorneo({ ...torneo, numZeros: parseInt(e.target.value)})}} disabled={!isTorneoEditable || torneo.championType === 'Liga'}/>
          </MDBCol>
          <MDBCol className="mb-3" md="2" sm="12">
            <MDBInput type='number' size="lg" label="Num. Juegos" defaultValue={torneo.numJuegos} onChange={(e)=>{setTorneo({ ...torneo, numJuegos: parseInt(e.target.value)})}} disabled={!isTorneoEditable || torneo.championType === 'Liga'}/>
          </MDBCol>
          <MDBCol className="mb-3" md="2" sm="12">
            <MDBInput type='number' size="lg" label="Num. Vueltas" defaultValue={torneo.turns} onChange={(e)=>{setTorneo({ ...torneo, turns: parseInt(e.target.value)})}} disabled={!isTorneoEditable || torneo.championType !== 'Liga'}/>
          </MDBCol>
          <MDBCol md="6" sm="12">            
            <MDBDropdown className={`mb-3 shadow-0 musDropdown`} group color='light' label="Tipo de Torneo" value={torneo.championType} disabled={!isTorneoEditable}>
              <MDBBtn className={`w-100 musLight`} color='light' size='lg'>{torneo.championType}</MDBBtn>
              <MDBDropdownToggle size='lg' split ></MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link childTag='button' onClick={(e)=>{setTorneo({ ...torneo, championType: 'EliminatoriaCondicionada'})}}>
                  Eliminatoria Condicionada
                </MDBDropdownItem>
                <MDBDropdownItem link childTag='button' onClick={(e)=>{setTorneo({ ...torneo, championType: 'EliminatoriaNoCondicionada'})}}>
                  Eliminatoria No Condicionada
                </MDBDropdownItem>
                <MDBDropdownItem link childTag='button' onClick={(e)=>{setTorneo({ ...torneo, championType: 'Liga'})}}>
                  Liga
                </MDBDropdownItem>
                <MDBDropdownItem link childTag='button' onClick={(e)=>{setTorneo({ ...torneo, championType: '...'})}}>
                  ...
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBCol>
        </MDBRow>
        <MDBTable striped align='middle'>
          <TableHeader light>
            <tr>
              <th scope='col' style={{'width':'75px'}}>Nº</th>
              <th scope='col'>Pareja</th>
              <th scope='col' style={hiddeColumnsBool ? {'width':'100px'} : {'width':'200px'}} className='text-center'>Acciones</th>
            </tr>
          </TableHeader>
          <TableBody>
            {/* {torneo.doublets.sort((a, b) => {
                        return a.id-b.id;
                      }).map((item, index) => { */}
            {torneo.doublets.map((item, index) => {
              return (
                <tr>
                  <td>
                    <MDBInput type='text' size="lg" value={item.id} disabled={true}/>
                  </td>
                  <td>
                    <MDBInput type='text' size="lg" value={item.nameDoublet} onChange={(e)=>{item.nameDoublet = e.target.value; setTorneo({...torneo, doublets: [...torneo.doublets]})}} disabled={!isTorneoEditable}/> 
                  </td>
                  <td className='text-center'>
                    <MDBBtn className={hiddeColumnsBool ? 'musButton-sm-icon-table' : 'musButton-sm-table'} outline onClick={()=>{setDoubletToDelete(item.id);setShowConfirmation(true)}}  disabled={!isTorneoEditable}>
                      <MDBIcon className={hiddeColumnsBool ? '' : 'me-2'} fas icon='trash' /> {hiddeColumnsBool ? '' : 'Eliminar Pareja'}
                    </MDBBtn>
                  </td>
                </tr>
              )
              })}
          </TableBody>
        </MDBTable>
      </PageBody>
    </>
  );
}
